var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuymenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".287869px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m6.854 1.112-.172.892-6.497-.033.687 4.454 5.78.05.774-4.727.93.007.013-.633ZM1.052 2.745l1.367.036.143 1.187H1.328Zm2.04.03 1.785.002-.154 1.175-1.5-.021Zm3.471.044-.22 1.21-.98-.03.186-1.173ZM3.312 4.517l1.378.002-.122 1.062-1.19-.02Zm1.995.027.97.008-.22 1.066-.882-.017Zm-3.869.012 1.19.008.132.974-1.168.016zm-.41 2.014a.577.577 0 0 0-.576.577.577.577 0 0 0 .577.577.577.577 0 0 0 .576-.577.577.577 0 0 0-.576-.577Zm5.457.031a.577.577 0 0 0-.577.577.577.577 0 0 0 .577.577.577.577 0 0 0 .577-.577.577.577 0 0 0-.577-.577Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuymenu);
export default __webpack_public_path__ + "static/media/buymenu.c982ce062a5c896c34e19ff13e73c51a.svg";
export { ForwardRef as ReactComponent };